import { getFacebookVanity } from '@change-corgi/config/facebook';
import { getInstagramHandle } from '@change-corgi/config/instagram';
import { getTiktokHandle } from '@change-corgi/config/tiktok';
import { getTwitterHandle } from '@change-corgi/config/twitter';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useConnectLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const countryCode = useCountryCode();
	const locale = useLocale();
	const twitterHandle = getTwitterHandle({ locale, countryCode });
	const facebookVanity = getFacebookVanity({ locale, countryCode });
	const instagramHandle = getInstagramHandle({ locale, countryCode });
	const tiktokHandle = getTiktokHandle({ locale, countryCode });

	return processLinkGroup({
		title: translate('fe.components.footer.connect'),
		links: [
			{
				href: `https://twitter.com/${twitterHandle}`,
				title: translate('fe.components.footer.twitter'),
				target: '_blank',
			},
			{
				href: `https://www.facebook.com/${facebookVanity}`,
				title: translate('fe.components.footer.facebook'),
				target: '_blank',
			},
			...(instagramHandle
				? [
						{
							href: `https://www.instagram.com/${instagramHandle}`,
							title: translate('fe.components.footer.instagram'),
							target: '_blank',
						},
					]
				: []),
			...(tiktokHandle
				? [
						{
							href: `https://www.tiktok.com/@${tiktokHandle}`,
							title: translate('fe.components.footer.tiktok'),
							target: '_blank',
						},
					]
				: []),
		],
	});
}
